/**
 * Format destination ID to display name
 * @param {string} destinationId - The destination ID (e.g., 'disney_world', 'universal_orlando')
 * @returns {string} - Formatted destination name (e.g., 'Disney World', 'Universal Studios')
 */
export const formatDestinationName = (destinationId) => {
  if (!destinationId) return '';
  
  const destinationMap = {
    'disney_world': 'Disney World',
    'disneyland': 'Disneyland',
    'disney_cruise': 'Disney Cruise',
    'universal_orlando': 'Universal Studios',
    'universal_studios': 'Universal Studios'
  };
  
  return destinationMap[destinationId.toLowerCase()] || destinationId;
};

